import React from "react";
import { useLocationStore } from "./hooks/useLocationStore";
import "./assets/style/Footer.css";

const Footer = () => {
  const mainLocations = useLocationStore((state) => state.mainLocations);

  const getGoogleMapsUrl = (address) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 footer-contact">
              <h3>Natchnienie Studio</h3>
              {mainLocations.length > 0 ? (
                <div className="footer-locations">
                  {mainLocations.map((location) => (
                    <a
                      key={location.id}
                      href={getGoogleMapsUrl(location.address)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-location-link"
                    >
                      <i className="bx bx-map"></i>
                      <span>{location.name}{location.address ? ` — ${location.address}` : ''}</span>
                    </a>
                  ))}
                </div>
              ) : (
                <a
                  href={getGoogleMapsUrl(process.env.REACT_APP_CONTACT_ADDRESS)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-location-link"
                >
                  <i className="bx bx-map"></i>
                  <span>{process.env.REACT_APP_CONTACT_ADDRESS}</span>
                </a>
              )}
              <p>
                <strong>Telefon:</strong> {process.env.REACT_APP_CONTACT_PHONE1}
                <br />
                <strong>Email:</strong> {process.env.REACT_APP_CONTACT_EMAIL}
              </p>
            </div>

            <div className="col-lg-6 col-md-6 footer-links">
              <h4>Nasze media społecznościowe</h4>
              <div className="social-links mt-3">
                <a
                  href="https://www.facebook.com/p/Natchnienie-studio-100090082840237/"
                  className="facebook"
                >
                  <i className="bx bxl-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/natchnieniestudio/"
                  className="instagram"
                >
                  <i className="bx bxl-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container footer-bottom">
        <div className="copyright">
          &copy; Copyright{" "}
          <strong>
            <span>Natchnienie Studio</span>
          </strong>
          . All Rights Reserved
        </div>
        <div className="footer-badge">
          <a
            href="https://www.kayak.de/Żukowo.66204.guide"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="kayak-badge"
              src="https://content.r9cdn.net/res/images/horizon/ui/seo/marketing/poibadges/POI_BADGES_GUIDES_DARK.png?v=3141cb0739e493843a37b32eccb35318b9d646ff&cluster=5"
              alt="Kayak Żukowo guide badge"
            />
          </a>
        </div>
        <div className="credits">
          <a href={`${process.env.REACT_APP_BACKEND_ADDRESS}/rodo/`} target="_blank" rel="noopener noreferrer">
            Klauzula RODO
          </a>
          <span className="separator">|</span>
          <a href={`${process.env.PUBLIC_URL}/statute`} target="_blank" rel="noopener noreferrer">
            Regulamin
          </a>
          <span className="separator">|</span>
          <a href={process.env.REACT_APP_PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer">
            Polityka prywatności
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
